import { Component } from '@angular/core';

@Component({
  selector: 'aboca-vertical-centered-container',
  templateUrl: './vertical-centered-container.component.html',
  styleUrls: ['./vertical-centered-container.component.scss'],
})
export class VerticalCenteredContainerComponent {}
